import {UyapRequest} from "./UyapRequest";

export interface DosyaSafahatTalep {
    dosyaId: string | number
    token: string | number
}

export interface DosyaSafahatCevap {
    safahatlar: Array<ISafahat>,
    showPersonel: boolean,
    sonuc: boolean,
    id: string,
    isCompressed: boolean,
    htmlHataKodList: Array<any>,
    isMock: boolean,
    message: string
}

export interface ISafahat {
    islemYapanBirim: string,
    safahatTarihi: string,
    safahatTarihiSTR: string,
    safahatTuruKod: number,
    aciklama?: string,
    safahatStatuKodAciklama: string,
    personel: string,
    showPersonel: boolean,
    sonuc: boolean,
    id: string,
    isCompressed: boolean,
    htmlHataKodList: Array<any>,
    isMock: boolean,
    safahatTuruAciklama?: string,
    safahatStatuKod?: number
}


export class DosyaSafahat extends UyapRequest<DosyaSafahatTalep, DosyaSafahatCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return {"safahatlar":[{"islemYapanBirim":"Ankara 2. Genel İcra Dairesi","safahatTarihi":"Apr 24, 2024 11:34:38 AM","safahatTarihiSTR":"24/04/2024 11:34","safahatTuruKod":188,"aciklama":"Avukat NİHAN ERDOĞAN tarafından, MUSTAFA SERDAR KAYAOĞLU adlı kişi  adres sorgulaması yapıldı.Sorgu Sonucu YOK","safahatStatuKodAciklama":"","personel":" AVUKAT PORTAL İŞLEMİ","showPersonel":true,"sonuc":false,"id":"10262720375557324574740150562533341231327173","isCompressed":false,"htmlHataKodList":[],"isMock":false},{"islemYapanBirim":"Ankara 2. Genel İcra Dairesi","safahatTarihi":"Apr 20, 2024 1:09:38 PM","safahatTarihiSTR":"20/04/2024 13:09","safahatTuruKod":253,"safahatTuruAciklama":"Gelir İdaresi Başkanlığı TC No dan Merkez Bilgisi Sorgulandı. ","aciklama":"Avukat NİHAN ERDOĞAN tarafından, MUSTAFA SERDAR KAYAOĞLU adlı kişi Gelir İdaresi Başkanlığı TC No dan Merkez Bilgisi Sorgulandı.  Sorgu Sonucu: VAR","safahatStatuKodAciklama":"","personel":" AVUKAT PORTAL İŞLEMİ","showPersonel":true,"sonuc":false,"id":"16227502210540334103416250375067353250500305","isCompressed":false,"htmlHataKodList":[],"isMock":false},{"islemYapanBirim":"Ankara 2. Genel İcra Dairesi","safahatTarihi":"Apr 20, 2024 1:09:33 PM","safahatTarihiSTR":"20/04/2024 13:09","safahatTuruKod":188,"aciklama":"Avukat NİHAN ERDOĞAN tarafından, MUSTAFA SERDAR KAYAOĞLU adlı kişi  adres sorgulaması yapıldı.Sorgu Sonucu YOK","safahatStatuKodAciklama":"","personel":" AVUKAT PORTAL İŞLEMİ","showPersonel":true,"sonuc":false,"id":"3361215000110147525661526740415115564753321","isCompressed":false,"htmlHataKodList":[],"isMock":false},{"islemYapanBirim":"Ankara 2. Genel İcra Dairesi","safahatTarihi":"Apr 20, 2024 1:09:23 PM","safahatTarihiSTR":"20/04/2024 13:09","safahatTuruKod":188,"aciklama":"Avukat NİHAN ERDOĞAN tarafından, MUSTAFA SERDAR KAYAOĞLU adlı kişi  adres sorgulaması yapıldı. Sorgu Sonucu: VAR","safahatStatuKodAciklama":"","personel":" AVUKAT PORTAL İŞLEMİ","showPersonel":true,"sonuc":false,"id":"6615207347530246515676530473053275542253531","isCompressed":false,"htmlHataKodList":[],"isMock":false},{"islemYapanBirim":"Ankara 2. Genel İcra Dairesi","safahatTarihi":"Mar 5, 2024 3:29:24 PM","safahatTarihiSTR":"05/03/2024 15:29","safahatTuruKod":188,"aciklama":"Avukat NİHAN ERDOĞAN tarafından, MUSTAFA SERDAR KAYAOĞLU adlı kişi  adres sorgulaması yapıldı. Sorgu Sonucu: VAR","safahatStatuKodAciklama":"","personel":" AVUKAT PORTAL İŞLEMİ","showPersonel":true,"sonuc":false,"id":"2651425312470255435056615564533365622601760","isCompressed":false,"htmlHataKodList":[],"isMock":false}],"showPersonel":true,"sonuc":false,"id":"442512736161532460610340603111177175123753","isCompressed":false,"htmlHataKodList":[],"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'dosya_safahat_bilgileri_brd.ajx';
    }

    async parse(data: any): Promise<DosyaSafahatCevap> {
        data.message="Sorgulama Başarılı";
        return data;
    }
}

export default DosyaSafahat;
